"use client";
import Image from "next/image";
import AnimatedText from "@/components/common/AnimatedText";
import ModalVideo from "react-modal-video";
import { useEffect, useState } from "react";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { HiOutlineEnvelope } from "react-icons/hi2";
export default function About() {
  const [about, setAbout] = useState(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [contactus, setContactus] = useState(null);

  useEffect(() => {
    const fetchcontactus = async () => {
      try {
        const response = await fetch("/api/contactus");
        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            const contact = data[0];
            setContactus(contact);
            setEmail(contact.email);
            setPhone(contact.mobile);
          }
        }
      } catch (error) {
        console.error("Failed to fetch Contact:", error);
      }
    };
    fetchcontactus();
  }, []);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await fetch("/api/web-content");
        if (response.ok) {
          const data = await response.json();
          if (data?.about) {
            setAbout(data.about);
          }
        }
      } catch (error) {
        console.error("Failed to fetch About:", error);
      }
    };
    fetchAbout();
  }, []);

  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <section
        id="about"
        className="about-section fix section-padding scrollSpySection"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="row">
              <div className="col-lg-6">
                <div className="about-image">
                  <div className="about-us-images">
                    <div className="about-image-box-1">
                      <div className="about-us-img-1">
                        <figure className="image-anime reveal">
                          <Image
                            src="/assets/img/about1.png"
                            alt=""
                            width={923}
                            height={968}
                          />
                        </figure>
                      </div>
                      <div className="about-us-img-2">
                        <figure className="image-anime">
                         
                          <Image
                            src="/assets/img/about2.png"
                            alt=""
                            width={880}
                            height={914}
                          />
                        </figure>
                      </div>
                    </div>
                    <div className="about-image-box-2">
                      <div className="about-experience-box">
                        <figure className="image-anime">
                          <Image
                            src="/assets/img/about3.png"
                            alt=""
                            width={880}
                            height={914}
                          />
                        </figure>
                      </div>

                      <div className="about-us-img-3">
                        <figure className="image-anime">
                          <Image
                            src="/assets/img/about5.png"
                            alt=""
                            width={820}
                            height={860}
                          />
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 align-self-center">
                <div className="about-content">
                  <div className="section-title">
                    <h6 className="wow fadeInUp">
                      <span className="mini-dot"></span> About Arena Water Park
                    </h6>
                    <h2 className="splt-txt wow ">
                      <AnimatedText text="A Destination Where Fun Flows Non-Stop." />
                    </h2>
                  </div>

                  {about?.content ? (
                    <div
                      className="mt-3 mt-md-0 wow fadeInUp"
                      data-wow-delay=".4s"
                      dangerouslySetInnerHTML={{ __html: about.content }}
                    />
                  ) : (
                    <p
                      className="mt-3 mt-md-0 wow fadeInUp"
                      data-wow-delay=".4s"
                    >
                      Welcome to Arena Water Park — your ultimate destination
                      for water-park fun, leisure and recreation in
                      Visakhapatnam. Nestled amidst serene surroundings and
                      built for fun-seekers of all ages, Arena Water Park blends
                      thrilling water rides, family-friendly attractions and
                      relaxing amenities to deliver memorable experiences for
                      everyone.
                    </p>
                  )}

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="d-flex contabout">
                        <div className="icon">
                          <LiaPhoneVolumeSolid />
                        </div>
                        <div className="iconcontent">
                          Call Us At: <br />
                          <span>{phone}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex contabout">
                        <div className="icon">
                          <HiOutlineEnvelope />
                        </div>
                        <div className="iconcontent">
                          Mail Us At: <br />
                          <span>{email}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul
                    className="list-items wow fadeInUp mb-0"
                    data-wow-delay=".2s"
                  >
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      Designed for All Ages Groups
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      Exciting & Ever-Evolving Attractions
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check"></i>A Place to
                      Celebrate Fun & Togetherness
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      Safe, Clean & Family-First Environment
                    </li>

                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      Every Visit Feels Special
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our-approach-section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <p className="approach-tag">
                <span className="dot"></span> Our Approach
              </p>

              <h2 className="approach-title">Creating Waves of Joy</h2>

              <p className="approach-desc">
                Step into Arena Water Park where every zone bursts with energy
                Colour and excitement from Adrenaline pumping water rides and
                splash zones to lively music and immersive experiences, Every
                moment is crafted to entertain refresh and thrill.
              </p>

              {/* Mission + Vision */}
              <div className="row mt-4">
                <div className="col-md-6 d-flex">
                  <div className="icon">
                    <object
                      data="/assets/img/mission-icon.svg"
                      type="image/svg+xml"
                      width={40}
                      height={40}
                    ></object>
                  </div>
                  <div className="ms-3">
                    <h5 className="mini-title">Our Mission</h5>
                    <p className="mini-desc">
                      To deliver fun adventure, and relaxation for all ages by
                      creating safe, vibrant unforgettable moments
                    </p>
                  </div>
                </div>

                <div className="col-md-6 d-flex">
                  <div className="icon">
                    <object
                      data="/assets/img/vision-icon.svg"
                      type="image/svg+xml"
                      width={40}
                      height={40}
                    ></object>
                  </div>
                  <div className="ms-3">
                    <h5 className="mini-title">Our Vision</h5>
                    <p className="mini-desc">
                      To become regions most loved Water Park destination,
                      bringing together families, friends, thrills seekers
                      through world class attractions
                    </p>
                  </div>
                </div>
              </div>

              {/* Button */}
              <div className="mt-4">
                <a href="/contact" className="contact-btn">
                  Contact Us
                </a>
              </div>
            </div>

            {/* RIGHT IMAGES */}
            <div className="col-lg-6 mt-4 mt-lg-0">
              <div className="row g-3 align-items-end">
                <div className="col-7">
                  <div className="img-box large">
                    <figure className="image-anime">
                      <Image
                        src="/assets/img/about4.png"
                        alt="kids"
                        width={400}
                        height={500}
                        className="img-fluid"
                      />
                    </figure>
                  </div>
                </div>

                <div className="col-5">
                  <div className="img-box small">
                    <figure className="image-anime">
                      <Image
                        src="/assets/img/about3.png"
                        alt="kid painting"
                        width={300}
                        height={400}
                        className="img-fluid"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our-vibes-section py-5 pb-0 mb-0">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <p className="vibes-tag">
                <span className="dot"></span> Our Vibes
              </p>

              <h2 className="vibes-title">
                Feel the splash, energy and excitement
              </h2>

              <p className="vibes-desc">
                Dive into the spirit of Arena Water Park where fun flows all
                year around from thrilling water, activities, attractions and
                splash filled adventures to lively events and unforgettable
                experiences. Every visit brings people together. We celebrate
                joy together and pure fun and we invite you to jump right in.
              </p>

              {/* Button */}
              <a href="/register" className="vibes-btn mt-3 d-inline-block">
                Create An Account
              </a>

              {/* Divider */}
              <hr className="divider my-4" />

              {/* Bottom Content */}
              <div className="row align-items-center">
                {/* Checklist */}
                <div className="col-md-6">
                  <ul className="vibes-list">
                    <li>
                      {" "}
                      <i className="fa-solid fa-circle-check"></i> Spreading
                      smiles everywhere
                    </li>
                    <li>
                      {" "}
                      <i className="fa-solid fa-circle-check"></i> Designing
                      magical experiences
                    </li>
                    <li>
                      {" "}
                      <i className="fa-solid fa-circle-check"></i> Uniting
                      people
                    </li>
                    <li>
                      {" "}
                      <i className="fa-solid fa-circle-check"></i> Creating
                      memories that last a lifetime
                    </li>
                  </ul>
                </div>

                {/* Small Image */}
                <div className="col-md-6">
                  <figure className="image-anime">
                    <div className="small-img-box" style={{ overflow: "hidden", borderRadius: "10px" }}>
                      <Image
                        src="/assets/img/about5.png"
                        alt="magic"
                        width={290}
                        height={200}
                        className="img-fluid"
                        style={{ objectFit: "cover", objectPosition: "center 20%", width: "100%", height: "200px" }}
                      />
                      <div className="overlay-text">Create Magic Moments</div>
                    </div>
                  </figure>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 mt-4 mt-lg-0">
              <div className="main-img-box">
                <figure className="image-anime">
                  <Image
                    src="/assets/img/about2.png"
                    alt="hero kid"
                    width={600}
                    height={700}
                    className="img-fluid"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>{" "}
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="Cn4G2lZ_g2I"
        onClose={() => setOpen(false)}
      />{" "}
    </>
  );
}
